import * as React from 'react';
import { useSelector } from 'react-redux';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import { getNewbuildingIdsForBuildersPromoSlider } from '../../selectors/newbuildingPromoCarousel';
import { NewbuildingPromoCarouselLoadableContainer } from './NewbuildingPromoCarouselLoadable';
import { NewbuildingPromoCarouselLayout } from '../../components/NewbuildingPromoCarouselLayout';
import { selectTotal } from '../../selectors/offersData';

export function LazyNewbuildingPromoCarouselContainer() {
  const [isVisible, setIsVisible] = React.useState(false);
  const newbuildingIds = useSelector(getNewbuildingIdsForBuildersPromoSlider);
  const total = useSelector(selectTotal);

  const handleShow = React.useCallback(() => {
    setIsVisible(true);
  }, []);

  if (!newbuildingIds.length || !total) {
    return null;
  }

  return (
    <ActionAfterViewed callback={handleShow} percentVisible={0.8}>
      <div>
        {isVisible && (
          <NewbuildingPromoCarouselLayout title="Популярные жилые комплексы от застройщиков">
            <NewbuildingPromoCarouselLoadableContainer newbuildingIds={newbuildingIds} />
          </NewbuildingPromoCarouselLayout>
        )}
      </div>
    </ActionAfterViewed>
  );
}
